export default __webpack_public_path__ + "static/media/background.2fa3e211.jpg";